import React from 'react';
import style from './HighLowIndicator.css';

import CenteredOnDecimal from '../CenteredOnDecimal/CenteredOnDecimal';

export const percentCalc = (value, low, high) => {
    const percent = 100 * ((value - low) / (high - low));
    return Math.max(0, Math.min(100, percent));
};

const HighLowIndicator = ({
    high = 0,
    low = 0,
    value = 0,
    formatter = (v) => v
}) => {
    const percent = percentCalc(value, low, high);

    return (
        <div className="indicator">
            <span className="low-value">
                <CenteredOnDecimal>{formatter(low)}</CenteredOnDecimal>
            </span>
            <span className="chart">
                <span className="bar" />
                <span className="diamond" style={{ left: `${percent}%` }} />
            </span>
            <span className="high-value">
                <CenteredOnDecimal>{formatter(high)}</CenteredOnDecimal>
            </span>
            <style jsx>{style}</style>
        </div>
    );
};

export default HighLowIndicator;
